import { useQuery } from '@tanstack/react-query'

import { useQueryWithStorage } from '@hooks/useQueryWithStorage'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import {
  initialState,
  searchProjectmeldingen,
} from '../services/searchProjectmeldingen'

import { useProjectmeldingenSearchStore } from './useProjectmeldingenSearchStore'

export { useProjectmeldingenSearch }

const queryKey = 'projectmeldingen'

const useQueryStore = () => {
  const { query, storeQuery } = useProjectmeldingenSearchStore()

  return useQueryWithStorage({
    initialState: initialState,
    query,
    storeQuery,
    queryKey,
  })
}

const useProjectmeldingenSearch = () => {
  const { onChangeFilters, onReset, query, onChangePage, onChangeSort } =
    useQueryStore()
  const { hasPermissions } = useAuthenticatedUser()

  const { data, refetch, isFetching, isError } = useQuery({
    queryKey: [queryKey, query],
    queryFn: () => searchProjectmeldingen({ query }),
    enabled: hasPermissions,
    refetchOnMount: true,
  })

  return {
    data: data || initialState.data,
    isLoading: isFetching,
    isError,
    filters: query.filters,
    initialFilters: initialState.query.filters,
    onChangeFilters,
    onReset,
    onRefresh: refetch,
    onChangePage,
    onChangeSort,
    sort: query.sort,
  }
}
